import { render, staticRenderFns } from "./no-internet-connection.vue?vue&type=template&id=23e4fae8&"
import script from "./no-internet-connection.vue?vue&type=script&lang=ts&"
export * from "./no-internet-connection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports